import { FC, useEffect, useState } from "react";
import { Col, DatePicker, Form } from "antd";

import { useSearchParams } from "react-router-dom";

import { IClient, IContract, IProduct } from "../../../../types";
import { getAllContracts } from "../../../contracts/list";
import { Select } from "../../../../components/Select";

import { ExpandableFilter } from "../../../../components/ExpandableFilter";
import { getClients, getContracts } from "../../../../services/repositories";
import dayjs from "dayjs";
import { getProducts } from "../../../products/list";

const { RangePicker } = DatePicker;

interface FilterProps {
  onSubmit: (values?: any) => void;
  filter?: any;
}

const Filter: FC<FilterProps> = ({ onSubmit, filter }) => {
  const [form] = Form.useForm();

  const [, setSearchParams] = useSearchParams();
  const [clients, setClients] = useState<IClient[]>([]);
  const [contracts, setContracts] = useState<IContract[]>([]);
  const [products, setProducts] = useState<IProduct[]>([]);

  useEffect(() => {
    if (filter) {
      form.setFieldsValue({
        ...filter,
        date: filter.date
          ? filter.date.map((endDate: string) => dayjs(endDate))
          : undefined,
      });
    }
  }, [form, filter]);

  useEffect(() => {
    if (clients.length === 0) {
      getClients(1, 1000).then(({ data }) => setClients(data));
    }
    if (filter?.clientId) {
      getAllContracts(1, 1000, { clientId: filter.clientId }).then(
        ({ data }) => {
          setContracts(data.data);
        }
      );
      getProducts(1, 1000).then(({ data }) => {
        setProducts(data.data);
      });
    }
  }, [filter, clients.length]);

  const onFinish = (values: any) => {
    const params = {
      ...values,
      startDate: values?.date?.[0]?.toISOString().slice(0, 10),
      endDate: values?.date?.[1]?.toISOString().slice(0, 10),
    };
    delete params.date;

    setSearchParams(params);
    onSubmit(params);
  };

  const onClear = () => {
    setSearchParams();
    onSubmit();
  };

  const loadContracts = async () => {
    await getContracts(
      {
        page: 1,
        perPage: 1000,
      },
      {
        clientId: form.getFieldValue("clientId"),
      }
    ).then(({ data }) => {
      setContracts(data);
    });
  };

  const fields = [
    <Col span={6} key={1}>
      <Form.Item
        name={"clientId"}
        label={"Cliente"}
        rules={[
          {
            required: true,
            message: "Selecione ao menos um cliente",
          },
        ]}
      >
        <Select
          optionLabelProp="label"
          optionFilterProp="label"
          showSearch
          allowClear
          options={clients}
          onChange={() => form.setFieldValue("contractId", null)}
          placeholder="Selecione um cliente"
        />
      </Form.Item>
    </Col>,
    <Col span={6} key={2}>
      <Form.Item label="Contrato" name="contractId">
        <Select
          optionLabelProp="label"
          optionFilterProp="label"
          showSearch
          allowClear
          options={contracts}
          handleLoadData={loadContracts}
          placeholder="Selecione um contrato"
        />
      </Form.Item>
    </Col>,
    <Col span={6} key={3}>
      <Form.Item label="Peças" name="partId">
        <Select
          optionLabelProp="label"
          optionFilterProp="label"
          showSearch
          allowClear
          options={products.map((product) => {
            return {
              label: product.name,
              value: product.id,
            };
          })}
          placeholder="Selecione a peça"
        />
      </Form.Item>
    </Col>,
    <Col span={6} key={4}>
      <Form.Item shouldUpdate noStyle>
        <Form.Item name={"date"} label={"Período"}>
          <RangePicker
            format="DD/MM/YYYY"
            style={{ width: "100%" }}
            allowClear
          />
        </Form.Item>
      </Form.Item>
    </Col>,
  ];

  return (
    <ExpandableFilter
      form={form}
      fields={fields}
      onFinish={onFinish}
      onClear={onClear}
    />
  );
};

export { Filter };
